import * as React from 'react';
import injectSheet from 'react-jss';
import { withRouter } from 'react-router';
import { Row, Col, Button } from 'antd';
import DailyMisReport from './DaliyMisReport';
import { connect } from 'react-redux';

const styles = (theme: any) => ({
  dataContainer: {
    marginTop: '20px',
    maxHeight: window.screen.height * 0.7,
    overflowY: 'auto',
  },
  misIframe: {
    border: 'none',
  },
  transparentButton: {
    background: 'transparent',
    border: 'none',
    color: '#565656',
    fontSize: '14px',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
      background: 'transparent !important',
      boxShadow: 'none',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
});

class MISReportView extends React.PureComponent<any, any>{

  state = {
    dashboardUrl: '',
  };

  async componentDidMount() {
    const { getDashboardUrl } = this.props;
    const dashboardUrl = await getDashboardUrl();
    this.setState({ dashboardUrl });
  }

  renderFrame = () => {
    return (
      <Col>
        <div>
          <iframe
            className={this.props.classes.misIframe}
            width="100%" height={window.screen.height}
            src={this.state.dashboardUrl}
          ></iframe>
        </div>
      </Col>
    );
  }

  renderDailyMisReport = () => {
    const { classes, viewType, organisationName } = this.props;
    return <Row
      className={classes.dataContainer}
      gutter={25}>
      <DailyMisReport viewType={viewType}/>
    </Row>;
  }

  render() {
    const { classes, hideDailyMisReport } = this.props;
    return (
           <div
           style={{ marginLeft: '20px', marginTop: '15px' }}
           >
          <Button
            icon={'arrow-left'}
            onClick={() => {
              this.props.onBack(false);
            }}
            className={classes.transparentButton}>
            Back
          </Button>
        <Row className={classes.dataContainer} gutter={25}>
          { hideDailyMisReport ? null :this.renderDailyMisReport() }
          {
            this.renderFrame()
          }
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ masterData }, {}): any => ({
  viewType: masterData.userData.type,
});

const MISReportViewStyled = connect(mapStateToProps)(injectSheet(styles)(MISReportView));
export default withRouter(MISReportViewStyled);
